/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type KingdomSettingsOverridableBlacklistDomainsQueryVariables = GraphQL.Exact<{ [key: string]: never; }>;


export type KingdomSettingsOverridableBlacklistDomainsQuery = { readonly __typename?: 'Query', readonly kingdomSettings: { readonly __typename?: 'KingdomSettings', readonly overridableBlacklistDomains: ReadonlyArray<string> } | null };


export const KingdomSettingsOverridableBlacklistDomainsDocument = gql`
    query KingdomSettingsOverridableBlacklistDomains {
  kingdomSettings {
    overridableBlacklistDomains
  }
}
    `;

/**
 * __useKingdomSettingsOverridableBlacklistDomainsQuery__
 *
 * To run a query within a React component, call `useKingdomSettingsOverridableBlacklistDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKingdomSettingsOverridableBlacklistDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKingdomSettingsOverridableBlacklistDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKingdomSettingsOverridableBlacklistDomainsQuery(baseOptions?: Apollo.QueryHookOptions<KingdomSettingsOverridableBlacklistDomainsQuery, KingdomSettingsOverridableBlacklistDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KingdomSettingsOverridableBlacklistDomainsQuery, KingdomSettingsOverridableBlacklistDomainsQueryVariables>(KingdomSettingsOverridableBlacklistDomainsDocument, options);
      }
export function useKingdomSettingsOverridableBlacklistDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KingdomSettingsOverridableBlacklistDomainsQuery, KingdomSettingsOverridableBlacklistDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KingdomSettingsOverridableBlacklistDomainsQuery, KingdomSettingsOverridableBlacklistDomainsQueryVariables>(KingdomSettingsOverridableBlacklistDomainsDocument, options);
        }
export function useKingdomSettingsOverridableBlacklistDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KingdomSettingsOverridableBlacklistDomainsQuery, KingdomSettingsOverridableBlacklistDomainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KingdomSettingsOverridableBlacklistDomainsQuery, KingdomSettingsOverridableBlacklistDomainsQueryVariables>(KingdomSettingsOverridableBlacklistDomainsDocument, options);
        }
export type KingdomSettingsOverridableBlacklistDomainsQueryHookResult = ReturnType<typeof useKingdomSettingsOverridableBlacklistDomainsQuery>;
export type KingdomSettingsOverridableBlacklistDomainsLazyQueryHookResult = ReturnType<typeof useKingdomSettingsOverridableBlacklistDomainsLazyQuery>;
export type KingdomSettingsOverridableBlacklistDomainsSuspenseQueryHookResult = ReturnType<typeof useKingdomSettingsOverridableBlacklistDomainsSuspenseQuery>;
export type KingdomSettingsOverridableBlacklistDomainsQueryResult = Apollo.QueryResult<KingdomSettingsOverridableBlacklistDomainsQuery, KingdomSettingsOverridableBlacklistDomainsQueryVariables>;